// Remove Gift Card Variant Label
function stripOptionText() {
  document.querySelectorAll('.clickyboxes.options-gift-card-value li a').forEach(a => {
    Array.from(a.childNodes).forEach(node => {
      if (node.nodeType === 3 && node.nodeValue.trim() !== '') { node.remove() }
    });
  });
}

document.addEventListener('DOMContentLoaded', stripOptionText);
new MutationObserver(stripOptionText).observe(document.body, { childList: true, subtree: true });
// Remove Gift Card Variant Label END


document.addEventListener('DOMContentLoaded', function() {
    if (window.location.pathname === '/products/nummy-scoop-free-gift') {
      window.location.href = '/products/nummy-scoop-gold-stainless-steel-measuring-spoon';
    }
  });

document.addEventListener('scroll', function () {
  const button = document.querySelector('.coffee-cta-button');
  if (!button) return;
  if (window.scrollY > 1100) { button.classList.add('fixed-cta') } 
  else { button.classList.remove('fixed-cta') }
});
document.addEventListener('DOMContentLoaded', function () {
  gsap.registerPlugin(ScrollTrigger);

  function setupStickyHeadings() {
    const isMobile = window.innerWidth <= 768;

    // Kill any existing ScrollTriggers to avoid duplicates
    ScrollTrigger.getAll().forEach(t => t.kill());

    // Collect all sticky heading wrappers (from both sections)
    const wrapper = document.querySelectorAll(
      '.section-gallery .cus-heading-wrapper, .section-text-columns-with-images .cus-heading-wrapper'
    );

    wrapper.forEach(wrapper => {
      // Reset for desktop
      if (!isMobile) {
        wrapper.style.position = '';
        wrapper.style.top = '';
        wrapper.style.zIndex = '';
        wrapper.style.background = '';
        return;
      }

      // Apply sticky styles
      // wrapper.style.position = 'sticky';
      // wrapper.style.top = '70px';
      // wrapper.style.zIndex = '11000';
      // wrapper.style.background = '#fff';
      // wrapper.style.width = '100vw';
      // wrapper.style.left = '50%';
      // wrapper.style.transform = 'translateX(-50%)';

      // Find parent section
      const parentSection =
        wrapper.closest('.section-gallery') ||
        wrapper.closest('.section-text-columns-with-images');

      if (!parentSection) return;

      // Pin heading with GSAP
      ScrollTrigger.create({
        trigger: parentSection,
        start: "top top+=70",
        end: () => "+=" + parentSection.offsetHeight,
        pin: wrapper,
        pinSpacing: false,
        anticipatePin: 1
      });
    });
  }

  setupStickyHeadings();
  window.addEventListener('resize', setupStickyHeadings);
});
$(document).ready(function() {
  $('.cus-addtocart-buy').each(function() {
    theme.applyAjaxToProductForm($(this)); // wrap with $()!
  });
});


//Pack Quick View - Js
document.addEventListener('click', (e) =>{
  let item = e.target;

  if(item.closest('.btn--quick-view')){
    let parent = item.closest('.pack-block');
    parent.classList.contains('quick-view--active') ? '' : parent.classList.add('quick-view--active');
  }

  if(item.closest('.pack--quick-view--close') || item.closest('.pack--quick-view--overlay')){
    let parent = item.closest('.pack-block');
    parent.classList.contains('quick-view--active') ? parent.classList.remove('quick-view--active') : '' ;
  }
})

window.updateCartQuantities = async (item) => {
  try {
    const updates = {};

    const timeStamp = item.getAttribute('timestamp');
    document.querySelectorAll(`cart-form form [timestamp="${timeStamp}"]`)?.forEach(element => {
      updates[element?.closest('li.cart-item')?.getAttribute('data-key')] = 0;
    });
    
    // updates[lineItemKey] = 0;
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ updates }) 
    })

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`HTTP error! Status: ${response.status}. Details: ${JSON.stringify(errorData)}`);
    }

    window.location.reload();

  } catch (error) {
    console.error('Error updating cart:', error);
  }
};


// Mega Menu 
document.addEventListener('mouseover', (e) => {
  let item = e.target;

  if(item.closest('.ctm-mega-menu--trigger')){
    let i = item.closest('.ctm-mega-menu--trigger');
    let megaMenu = i.nextElementSibling;
    megaMenu.classList.add('ctm-mega-menu-content---active');
    megaMenu.addEventListener('mouseleave', () => {
      megaMenu.classList.remove('ctm-mega-menu-content---active');
      console.log('Mouse left the mega menu area.');
    });
  }
})

// Select the element
const siteControl = document.getElementById('site-control');

if(siteControl){
  window.addEventListener('scroll', () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const position = siteControl.dataset.positioning; // 'sticky' or 'peek'
    const hasClass = siteControl.classList.contains('announcement-hidden');
  
    if ((position === 'sticky' || position === 'peek') && scrollTop >= 50) {
      if (!hasClass) { siteControl.classList.add('announcement-hidden') }
    } else {
      if (hasClass) { siteControl.classList.remove('announcement-hidden') }
    }
  });
}
//Mega Menu End

// Close sidebar when clicking outside
(function () {
  const pageMenu = document.getElementById('page-menu');
  const menuToggle = document.querySelector('a[data-modal-nav-toggle]');

  if (!pageMenu || !menuToggle) return;

  document.addEventListener('click', function (e) {
    // Menu is open when 'reveal' class is present on #page-menu
    if (!pageMenu.classList.contains('reveal')) return;

    const clickedInsideMenu = pageMenu.contains(e.target);
    const clickedToggle = menuToggle.contains(e.target);

    if (!clickedInsideMenu && !clickedToggle) {
      menuToggle.click();
    }
  });
})();


// Script to reorder Volume Discount block + Free Gift block on PDP starts
(function () {

  function reorderBlocks() {
    console.log("Blcoks reordered !!")

    const appstleWrapper = document.querySelector('.appstle_subscription_wrapper');
    const bmsm = document.getElementById('bmsm-volume-discount-block');
    const freeGiftBlock = document.querySelector('.nummy-free-bag-offer');
    const atcAction = document.querySelector('.product-detail__form__action');

    // Ensure all required elements exist
    if (!appstleWrapper || !bmsm || !freeGiftBlock || !atcAction) {
      return false;
    }

    // STEP 1:
    // Move Volume Discount block right below Appstle Subscription block
    appstleWrapper.insertAdjacentElement('afterend', bmsm);

    // STEP 2:
    // Move Free Gift block right below Volume Discount block
    bmsm.insertAdjacentElement('afterend', freeGiftBlock);

    return true;
  }

  let attempts = 0;

  const interval = setInterval(function () {

    attempts++;

    const done = reorderBlocks();

    // Stop checking once successful
    // or after max attempts
    if (done || attempts >= 40) {
      clearInterval(interval);
    }

  }, 150);

})();
// Script to reorder Volume Discount block + Free Gift block on PDP ends

// Script of free shipping bar starts
(function () {
  var bar = document.getElementById('FreeShippingBar');
  var nav = document.getElementById('site-control');
  if (!bar || !nav) return;

  function setBarTop() {
    bar.style.top = nav.offsetHeight + 'px';
    bar.style.visibility = 'visible';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setBarTop);
  } else {
    setBarTop();
  }

  if (window.ResizeObserver) {
    new ResizeObserver(setBarTop).observe(nav);
  }

  window.addEventListener('resize', setBarTop);
})();
// Script of free shipping bar ends